import useTranslate from "../../../../modules/local/useTranslate";
import React, {useMemo, useState} from "react";
import {NullAsDefault} from "../../../Shared";
import {useOrganizationDepartmentApi} from "./useOrganizationDepartmentApi";
import {showConfirmDialog, showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {createModalTitle} from "../../../../components/renderFunctions/createModalTitle";
import {getId} from "../../../../apis/model/base";
import {Modal} from "antd";
import {
    OrganizationDepartmentCreateForm,
    OrganizationDepartmentUpdateForm
} from "../components/OrganizationDepartmentForm";
import {DepartmentActionTypes} from "../../../Workspace/Host/WorkspaceMembers";
import {
    OrganizationDepartmentAddMemberForm,
    OrganizationDepartmentCreateMemberForm,
    OrganizationDepartmentUpdateMemberForm
} from "../components/OrganizationDepartmentMemberForm";
import {BsEyeSlashFill} from "react-icons/bs";


export const useOrganizationDepartmentForm = ({
                                                  organization,
                                                  organizationDepartment,
                                              }) => {
    const t = useTranslate()
    const [refreshToken, setRefreshToken] = useState()
    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })
    const onCancel = () => {
        setAction({})
    }
    const onRefresh = () => {
        onCancel()
        setRefreshToken(Date.now())
    }


    const {
        onCreate, creatingAsync,
        onUpdate, updatingAsync,
        onDelete, deletingAsync,
        addMember, addingMemberAsync,
        editMember, editingMemberAsync,
        removeMember, removingMemberAsync,
        setMemberActive, settingMemberActiveAsync
    } = useOrganizationDepartmentApi({
        notifyListeners: {
            onRefresh
        }
    })


    const handleAction = (action, params) => {
        switch (action) {
            case DepartmentActionTypes.DEPT_CREATE:
            case DepartmentActionTypes.DEPT_UPDATE:
            case DepartmentActionTypes.DEPT_ADD_MEMBER:
            case DepartmentActionTypes.DEPT_ADD_ORG_MEMBER:
            case DepartmentActionTypes.DEPT_EDIT_MEMBER:
                setAction({
                    type: action,
                    value: params,
                })
                break
            case DepartmentActionTypes.DEPT_DELETE:
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete this item',
                    message: 'are you sure you want to delete this',
                    onOk: () => {
                        onDelete({}, {id: params?.id})
                    },
                })
                break
            case DepartmentActionTypes.DEPT_DELETE_MEMBER:
                showConfirmDialog({
                    translate: t,
                    title: 'remove member',
                    message: 'are you sure you want to remove this member from the department',
                    onOk: () => {
                        removeMember({}, {id: params?.id})
                    },
                })
                break
            case DepartmentActionTypes.DEPT_MEMBER_SET_ACTIVE:
                showConfirmDialog({
                    icon: <BsEyeSlashFill className="anticon"/>,
                    translate: t,
                    title: !!!params?.active ? 'activate member' : 'deactivate member',
                    message: !!!params?.active
                        ? 'do you want to activate this member'
                        : 'do you want to deactivate this member',
                    onOk: () => {
                        setMemberActive({active: !!!params?.active ? 1 : 0}, {id: params?.id})
                    },
                })
                break
            default:
                break
        }
    }

    const modal = useMemo(() => {
        let params = {}
        let modal_params = {}
        let Component = NullAsDefault

        switch (action?.type) {
            case DepartmentActionTypes.DEPT_CREATE:
                modal_params = {
                    title: createModalTitle('create group / ministry'),
                    width: 600,
                }
                params = {
                    initialValues: {...(action?.value || {})},
                    isSubmitting: creatingAsync.isLoading,
                    onSubmit: (values) => {
                        onCreate(values, {id: organization?.id})
                    },
                }
                Component = OrganizationDepartmentCreateForm
                break
            case DepartmentActionTypes.DEPT_UPDATE:
                const organization_department_id = getId(action?.value)
                modal_params = {
                    title: createModalTitle('edit group / ministry'),
                    width: 600,
                }
                params = {
                    organizationDepartment,
                    organization,
                    organization_department_id,
                    initialValues: {...action?.value},
                    isSubmitting: updatingAsync.isLoading,
                    onSubmit: (values) => {
                        onUpdate(values, {id: organization_department_id})
                    },
                }
                Component = OrganizationDepartmentUpdateForm
                break
            case DepartmentActionTypes.DEPT_ADD_MEMBER:
                modal_params = {
                    title: createModalTitle('add member'),
                    width: 600,
                }
                params = {
                    organizationDepartment,
                    organization,
                    initialValues: {...(action?.value || {})},
                    isSubmitting: creatingAsync.isLoading,
                    onSubmit: (values) => {
                        addMember(values, {id: values?.organization_department_id})
                    },
                }
                Component = OrganizationDepartmentCreateMemberForm
                break
            case DepartmentActionTypes.DEPT_ADD_ORG_MEMBER:
                modal_params = {
                    title: createModalTitle('add member'),
                    width: 600,
                }
                params = {
                    organizationDepartment,
                    organization,
                    isSubmitting: creatingAsync.isLoading,
                    onSubmit: (values) => {
                        addMember(values, {id: values?.organization_department_id})
                    },
                }
                Component = OrganizationDepartmentAddMemberForm
                break
            case DepartmentActionTypes.DEPT_EDIT_MEMBER:
                const id = getId(action?.value)
                modal_params = {
                    title: createModalTitle('edit member'),
                    width: 600,
                }
                params = {
                    organization,
                    organizationDepartment,
                    initialValues: {...action?.value},
                    isSubmitting: updatingAsync.isLoading,
                    onSubmit: (values) => {
                        editMember(values, {id: id})
                    },
                }
                Component = OrganizationDepartmentUpdateMemberForm
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Component
                    {...{onCancel}}
                    {...params}
                    organization={organization}
                />
            </Modal>
        )
    }, [action, organization, creatingAsync.isLoading, updatingAsync.isLoading])

    return {
        modal,
        action,
        onCancel,
        handleAction,
        refreshToken,
    }
}